import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';

const PlayButton = ({ text, theme, thinIcon }) => {
  let icon = 'play-button';
  let viewBox = null;
  if (thinIcon) {
    icon = 'play-button-thin';
    viewBox = '1 1 36 36';
  }
  return (
    <div className={theme.play}>
      <Icon icon={icon} color="white" size="full" viewBox={viewBox} />
      {text && <div className={theme.playText}>{text}</div>}
    </div>
  );
};

PlayButton.defaultProps = {
  text: null,
  thinIcon: false,
};

PlayButton.propTypes = {
  text: PropTypes.string,
  theme: PropTypes.shape({}).isRequired,
  thinIcon: PropTypes.bool,
};

export default PlayButton;
